import { PositionType } from '@enview/interface/types/bills/PositionStatement';

export const POSITION_GREEN = '#2EA270';
export const POSITION_RED = '#DA5151';
export const POSITION_NEUTRAL = '#F79728';

export const getPositionColor = (positionType?: PositionType): string => {
  switch (positionType) {
    case PositionType.SUPPORT:
    case PositionType.PROACTIVE:
      return POSITION_GREEN;
    case PositionType.OPPOSE:
    case PositionType.DEFENSIVE:
      return POSITION_RED;
    default:
      return POSITION_NEUTRAL;
  }
};
